import React, { useState } from "react";
import login from "../../assets/authentication/bg.jpg";
import logo from "../../assets/crazzy-hub.png";
import { useFormik } from "formik";
// import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { getMessaging, getToken } from "firebase/messaging";
import Fingerprint2 from "fingerprintjs2";

import { toast } from "react-toastify";
import {
  Button,
  Checkbox,
  createTheme,
  FormHelperText,
  Modal,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { logInSchema } from "../../schema";
import { initializeApp } from "firebase/app";
import "../../index.css";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { useEffect } from "react";
import axiosInstance, { baseUrl } from "../../config/axios";

const SignIn = () => {
  const [registrationToken, setResgistrationToken] = useState("");
  const [deviceIdData, setDeviceIdData] = useState("");

  // const generateDeviceId = () => {
  //   Fingerprint2.get((components) => {
  //     const values = components.map((component) => component.value);
  //     const deviceId = Fingerprint2.x64hash128(values.join(""), 31);
  //     console.log("deviceId==>", deviceId); // You can use or store the generated device ID as per your requirements
  //     setDeviceIdData(deviceId);
  //   });
  // };

  // const messaging = getMessaging(
  //   initializeApp({
  //     apiKey: "AIzaSyDRmEp90O7Tj7PI-jJo_GF2oafoC29wGno",
  //     authDomain: "zzz-living.firebaseapp.com",
  //     databaseURL: "https://zzz-living-default-rtdb.firebaseio.com",
  //     projectId: "zzz-living",
  //     storageBucket: "zzz-living.appspot.com",
  //     messagingSenderId: "128538616643",
  //     appId: "1:128538616643:web:5ad9007b804045c7ae45f6",
  //     measurementId: "G-QK3EK3E89D",
  //   })
  // );

  // getToken(messaging, {
  //   vapidKey:
  //     "BBmpIskeXwBhogaduZVHfTe9OwtrgDStYO_mV8HYrVDQ9LptbheQKFhwWnq-G0cbRbyh3wDWGx3fAlQSYbZmOSQ",
  // })
  //   .then((currentToken) => {
  //     if (currentToken) {
  //       // Token is available
  //       setResgistrationToken(currentToken);
  //       console.log("Current token:", currentToken);
  //     } else {
  //       // Token is not available, request permission
  //       return requestNotificationPermission();
  //     }
  //   })
  //   .catch((error) => {
  //     console.log("Error getting token:", error);
  //   });

  // const requestNotificationPermission = () => {
  //   return Notification.requestPermission().then((permission) => {
  //     if (permission === "granted") {
  //       console.log("Notification permission granted.");
  //       return getToken(messaging, {
  //         vapidKey:
  //           "BBmpIskeXwBhogaduZVHfTe9OwtrgDStYO_mV8HYrVDQ9LptbheQKFhwWnq-G0cbRbyh3wDWGx3fAlQSYbZmOSQ",
  //       });
  //     } else {
  //       console.log("Notification permission denied.");
  //       // Handle permission denied case
  //     }
  //   });
  // };

  // console.log("token generate==>", registrationToken);

  const lightTheme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#1345B7",
      },
    },
  });

  const navigate = useNavigate();

  const initialValues = {
    email: "",
    password: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: logInSchema,
    onSubmit: (values, action) => {
      const reqBody = {
        email: values.email,
        password: values.password,
        registration_id: registrationToken,
        device_id: deviceIdData,
        type: "web",
      };

      axiosInstance
        .post(`api/admin/multi-vendor-admin-login/`, {
          ...reqBody,
        })
        .then((response) => {
          console.log("data", response?.data?.login_info_list);
          localStorage.setItem("role", response?.data.login_info_list?.role);
          localStorage.setItem("email", response?.data.login_info_list?.email);
          localStorage.setItem("Token", response?.data.login_info_list?.token);
          localStorage.setItem(
            "user_name",
            response?.data?.login_info_list?.user_name,
          );
          localStorage.setItem(
            "is_superuser",
            response?.data?.login_info_list?.is_superuser,
          );
          localStorage.setItem(
            "store_id",
            response?.data?.login_info_list?.store_id,
          );
          navigate("/dashboard");
          toast(response.data.message);
        })
        .catch((error) => {
          toast.error(
            error.message === "Request failed with status code 400"
              ? "You have Entered Wrong Credential"
              : "",
          );
        });
    },
  });

  useEffect(
    () => {
      localStorage.getItem("role") === "reseller"
        ? navigate("/resellers/dashboard")
        : localStorage.getItem("role") === "admin"
          ? navigate("/dashboard")
          : navigate("/");
    },
    // eslint-disable-next-line
    [],
  );

  return (
    <>
      <div className="flex bg_image">
        {/* <img
          src={bg_image}
          alt=""
          className="h-screen fixed object-cover w-screen"
          style={{backgroundAttachment:"fixed",backgroundSize:"cover"}}
        /> */}
        <div className="flex flex-col h-screen bg-white bg-opacity-70 items-center p-16 text-black w-[41.8%]">
          <img src={logo} alt="" className="h-28 z-20" />
          {/* <p className="text-2xl font-semibold mt-2">Sign In</p> */}
          <p className="mt-1 text-xs font-bold text-gray-600">
            Login into your account
          </p>
          <form
            onSubmit={formik.handleSubmit}
            className="flex flex-col w-full my-2"
          >
            <ThemeProvider theme={lightTheme}>
              <label className="py-1 mt-3 text-gray-600">
                Email Id<span className="text-red-400">*</span>
              </label>
              <div class="input-group rounded-md text-black h-11 !border-none !bg-white border-white focus:border-none">
                <input
                  type="email"
                  id="email"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.onBlur}
                  placeholder="info@provistechnologies.com"
                  className="px-2 passw"
                  style={{ fontWeight: "normal" }}
                />
                <span className="!rounded-[6px] bg-[#FF7202] text-white">
                  <MailOutlineIcon />
                </span>
              </div>
              <FormHelperText className="!text-red-700 px-1">
                {formik.errors["email"]}
              </FormHelperText>
              <label className="py-1 mt-3 text-gray-600">
                Password
                <span className="text-red-400">*</span>
              </label>
              <div class="input-group rounded-md text-black h-11 !border-none !bg-white border-white focus:border-none">
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formik.values["password"]}
                  onChange={formik.handleChange}
                  onBlur={formik.onBlur}
                  placeholder="Enter your password"
                  className="px-2 passw"
                />
                <span className=" bg-[#FF7202] text-white !rounded-[6px]">
                  <LockOutlinedIcon />
                </span>
              </div>
              <FormHelperText className="!text-red-700 px-1">
                {formik.errors["password"]}
              </FormHelperText>
              <div className="flex w-full my-4 items-center justify-between">
                <div className="flex items-center">
                  <Checkbox
                    className="!p-0 !pr-1 !border !border-white"
                    size="small"
                  />
                  <p className="cursor-pointer text-center text-sm text-blue-800">
                    Remember Me
                  </p>
                </div>
                <div>
                  <Link
                    to={"/reset-paasword"}
                    className="text-sm underline text-blue-800"
                  >
                    Forget Password
                  </Link>
                </div>
              </div>
              <div className="flex justify-center mt-5">
                <Button
                  variant="contained"
                  type={"submit"}
                  className="!px-10 !py-1.5 !w-full !capitalize !rounded-md"
                  style={{
                    background: "linear-gradient(180deg, #F76B1D, #F25335)",
                  }}
                >
                  Login now
                </Button>
              </div>
              <div className="mx-auto text-right py-4"></div>
            </ThemeProvider>
          </form>
          <div className="tracking-widest text-[#CF5E2B] font-bold text-2xl ">
            Powered By ERP
          </div>
        </div>
      </div>
    </>
  );
};

export default SignIn;
